import { IconButton } from '@mui/material';
import AddCircleRounded from '@mui/icons-material/AddCircleRounded';
import { useApi, useCurrentUser } from 'lib/contexts/ApplicationState';
import { useSignUpModal } from 'components/SignUpModal';
import { trackClickSignupEvent } from 'lib/hooks/useEventTracking';

interface Props {
  onClickAddTag: () => void;
  label?: string;
}

export const AddTagButton = ({ onClickAddTag, label = 'Add tag' }: Props) => {
  const currentUser = useCurrentUser();
  const { showSignUpModal } = useSignUpModal();
  const API = useApi();

  const tryToAddTag = () => {
    if (currentUser) {
      onClickAddTag();
    } else {
      trackClickSignupEvent(API, 'add-tag');
      showSignUpModal('Please sign up or sign in to add a tag to a post');
    }
  };

  return (
    <li>
      <IconButton
        aria-label={label}
        onClick={tryToAddTag}
        color="primary"
        sx={{ padding: 0 }}
      >
        <AddCircleRounded />
        <span className="ml-1 text-sm font-semibold">{label}</span>
      </IconButton>
    </li>
  );
};
